import { render, staticRenderFns } from "./Occasion.vue?vue&type=template&id=47d799ec&scoped=true"
import script from "./Occasion.vue?vue&type=script&lang=js"
export * from "./Occasion.vue?vue&type=script&lang=js"
import style0 from "./Occasion.vue?vue&type=style&index=0&id=47d799ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d799ec",
  null
  
)

export default component.exports